import React from 'react';
import logo from './logo.svg';
import './App.css';
import ProfitCalculator from './components/calculator/Calculator';
import ReactGA from "react-ga4";
import FloatingSidebarAd from './components/ad/ad';

ReactGA.initialize("G-KDJBB14D7R");
function App() {
  return (
    <div className="App">
     
      <ProfitCalculator/> 
      <FloatingSidebarAd/>
    </div>
  );
}

export default App;
